export default __webpack_public_path__ + "static/portfolio-5-866af9de52a24c3c11d45e1b0fc63026.jpg";